import React from 'react';
import { stages } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';

const FourStageSystem = () => {
  return (
    <section id="system" className="py-24 bg-zinc-900 border-y border-zinc-800 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-black uppercase tracking-tight mb-4">The Forge Protocol</h2>
          <p className="text-zinc-400 max-w-2xl mx-auto">A systematic, non-medical approach to mechanical recovery. Four stages designed to prepare, maintain, and restore your physical capacity.</p>
        </div>

        <div className="grid md:grid-cols-4 gap-8 relative">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-zinc-800"></div>

          {stages.map((stage, idx) => (
            <div key={idx} className="relative z-10 flex flex-col items-center text-center md:items-start md:text-left group">
              <div className="w-24 h-24 rounded-full bg-zinc-950 border-2 border-zinc-800 group-hover:border-red-600 transition-colors flex items-center justify-center mb-6 relative">
                <SafeIcon name={stage.icon} className="text-3xl text-zinc-400 group-hover:text-red-500 transition-colors" />
                <div className="absolute -top-2 -right-2 bg-red-600 text-xs font-bold px-2 py-1 rounded-sm">
                  {stage.step}
                </div>
              </div>
              <h3 className="text-xl font-bold text-white mb-2 uppercase">{stage.title}</h3>
              <p className="text-sm text-zinc-400 leading-relaxed">{stage.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FourStageSystem;